import React, { lazy } from 'react';
import styled from 'styled-components';

import { Box as MuiBox, Slider } from '@mui/material';

import { Typography } from 'components/ui';

export const SCalendarWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-top: 25px;
  padding-bottom: 25px;
  .react-calendar__month-view {
    width: 100%;
  }
  .react-calendar__year-view {
    width: 100%;
  }
  abbr {
    text-decoration: none;
    text-transform: none;
    font-size: 1rem;
  }
`;
//
// export const SSelectedDate = styled.div`
//   display: flex;
//   flex-direction: row;
//   padding-left: 137px;
//   margin-top: 25px;
//   margin-bottom: 15px;
//   align-items: center;
//
//   & > * {
//     margin-right: 5px;
//   }
// `;

// export const STitleWrap = styled.div`
//   min-width: 125px;
//   display: flex;
//   flex-direction: row;
//   margin-right: 12px;
// `;
//
// export const STagsWrap = styled.div`
//   max-width: 760px;
//   display: flex;
//   flex-direction: row;
//   flex-wrap: wrap;
// `;

export const STimeTag = styled((props) => {
  return <Typography variant="h5" {...props} />;
})`
  border: 1px solid ${({theme}) => theme.palette.colors.gray200};
  background-color: ${(props) =>
    props.isSelected ? props.theme.palette.colors.blue100 : props.theme.palette.colors.white};
  color: ${(props) =>
    props.isSelected ? props.theme.palette.colors.white : props.theme.palette.colors.black100};
  border-radius: 5px;
  padding: 5px 10px;
  margin: 0 8px 10px 0 !important;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
`;
// export const SEmptyHint = styled.span``;

export const CalendarWrapper = styled(MuiBox)`
  && {
    border-right: 1px solid ${({theme}) => theme.palette.colors.gray500};
    &:last-child {
      border-right: 0;
    }
  }
`;

export const SSlider = styled(Slider)`
  && {
    .MuiSlider-rail {
      height: 6px;
      background: ${({theme}) => theme.palette.colors.white};
      border: 1px solid ${({theme}) => theme.palette.colors.blue100};
      box-sizing: border-box;
    }
    .MuiSlider-track {
      height: 6px;
    }
    .MuiSlider-mark {
      width: 2px;
      height: 6px;
      color: ${({theme}) => theme.palette.colors.white};
      border-left: 1px solid ${ ({theme}) => theme.palette.colors.blue100 + '40' };
      border-right: 1px solid ${ ({theme}) => theme.palette.colors.blue100 + '40' };
      opacity: 1;
      
      &[data-index='0'] {
        display: none;
      }
      &[data-index='8'] {
        display: none;
      }
    }
    .MuiSlider-thumb {
      width: 20px;
      height: 20px;
      span {
        border-radius: 4px;
        padding: 5px;
        width: initial;
        white-space: nowrap;
        background: ${({theme}) => theme.palette.colors.blue200} !important; 
        color: ${({theme}) => theme.palette.colors.black};
      } 
      &::before {
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background: ${({theme}) => theme.palette.colors.white};
      }
    }
    .MuiSlider-valueLabel {
      left: calc(50%);
      transform: translateX(-50%) translateY(-40px);
      span {
        display: flex;
        align-items: center;
        border-radius: 4px;
        padding: 2px 5px;
        width: initial;
        white-space: nowrap;
        background: ${({theme}) => theme.palette.colors.blue200}; 
        color: ${({theme}) => theme.palette.colors.black};
      } 
    } 
  }
`;

export const STooltip = styled.div`
  && {
    display: flex;
    &::before {
      content: "";
      width: 0px;
      height: 0px;
      position: absolute;
      left: 50%;
      top: 100%;
      transform: translateX(-50%) translateY(-2px);
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 16px solid ${({theme}) => theme.palette.colors.blue200};
      z-index: 999;
    }
  }
`;

export const SMark = styled.span`
  color: ${({theme}) => theme.palette.colors.gray100};
`;

export const SlotsWrapper = styled.div`
  && {
    display: flex;
    max-width: 600px;
    flex-wrap: wrap;
    margin-top: 16px;
    justify-content: flex-start;
    align-items: flex-start;
    min-height: ${({ isNoSlots }) => isNoSlots ? '220px' : '0'};
    background: ${({ isNoSlots, theme }) => isNoSlots ? theme.palette.colors.gray100 : 'transparent'};
    border-radius: 8px;
    padding: ${({ isNoSlots }) => isNoSlots ? '20px' : '0'};
  }
`;

export const EmptyMessage = styled.div`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    padding: 40px 70px;
    text-align: center;
    color: ${({theme}) => theme.palette.colors.gray300};
    position: relative;
    background: ${({theme}) => theme.palette.colors.gray100};
    border-radius: 5px;
    & > span {
      display: block;
      position: relative;
      z-index: 1;
    }
  }
`;

export const SWrapper = styled.div`
&&{
  padding: 16px 0;
  display: flex;
  flex-direction: column;
}
 
`;

export const ScrollWrapper = styled.div`
&& {
  max-height: 160px;
  overflow-y: auto;
  font-size: 16px;
}

`;

export const InputWrapper = styled(MuiBox)`
&&{
  border-right: 1px solid ${({theme}) => theme.palette.colors.gray500};
  flex: 1;
  height: 100%;
  
  &:last-child {
    border-right: 0;
  }
}

`;
